<template>
	<article class="content"><h1>For-Oh Four</h1><p>"{{ path }}" is nowhere to be found.</p></article>
</template>

<script>
	export default {
		name: 'PageNotFound',
		computed: {
			path() {
			    return this.$route.path;
		    }
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/PageNotFound.vue